import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueMask',
})
export class AutocompleteValuePipe<ValueType> implements PipeTransform {
  transform(value: ValueType, mask: string): string {
    return this.getMaskValue(value, mask);
  }

  private getMaskValue(value: ValueType | null, mask: string): string | null {
    const valueMaskRegexp = /\b\w+\b/g;
    const keys = mask.match(valueMaskRegexp);
    let valueWithMask: string | null = null;

    if (keys?.length && value && typeof value === 'object') {
      valueWithMask = keys.reduce((acc: string, key: string) => {
        const keyValue = (value as { [fieldKey: string]: unknown })[key];

        if (keyValue !== null && key !== undefined) {
          acc = acc.replace(key, `${keyValue}`);
        }

        return acc;
      }, mask);
    }

    return valueWithMask;
  }
}
